import { Box, Typography } from '@mui/material';
import { StyleObj } from '../../../../@types';
import { ReactNode, useCallback } from 'react';
import { To, useNavigate } from 'react-router';
import { ChevronRight } from '@mui/icons-material';
import { mergeSx } from '../../../../utils/styles';
import useLocalization from '../../../../hooks/useLocalization';

const styles: StyleObj = {
  container: {
    px: 1.5,
    py: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'primary.main',
  },
  clickable: {
    cursor: 'pointer',
  },
  title: {
    color: 'neutral.100',
    typography: 'body2',
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  linkText: {
    color: 'info.100',
    fontSize: 10,
    lineHeight: 1.5,
  },
  linkIcon: {
    color: 'info.100',
    fontSize: 15,
  },
};

type HeadingProps = {
  children: ReactNode;
  to?: To;
};

const Heading = ({ children, to }: HeadingProps) => {
  const { t } = useLocalization();
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    if (to) {
      navigate(to);
    }
  }, [navigate, to]);

  return (
    <Box sx={mergeSx(styles.container, to && styles.clickable)} onClick={handleClick}>
      <Typography sx={styles.title}>{children}</Typography>
      {to && (
        <Box sx={styles.link}>
          <Typography sx={styles.linkText}>{t('goToMatches')}</Typography>
          <ChevronRight sx={styles.linkIcon} />
        </Box>
      )}
    </Box>
  );
};

export default Heading;
